const knownErrors = [
  'DUPLICATES_DETECTED',
  'UNABLE_TO_LOCK_ROW',
  'CANNOT_EXECUTE_FLOW_TRIGGER'
]

function SFErrorHandler(SFError: Error) {
  if (knownErrors.some(errorMessage => SFError.message?.includes(errorMessage))) {
    console.warn(SFError.message)
    return SFError
  }

  throw SFError
}
export { SFErrorHandler }
